module.exports = __webpack_public_path__ + "img/mountain_winter_break.ae657af0.jpg";